export async function sha256hex(text: string): Promise<string> {
  const buf = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text))
  return Array.from(new Uint8Array(buf))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}

/**
 * A letter's cache key (FR-AI14): the same style, model and data give the same id, so an
 * unchanged request reuses its letter, and changing any of them writes a new one.
 */
export function letterSnapshotId(mode: string, model: string | undefined, payload: unknown): Promise<string> {
  return sha256hex(JSON.stringify({ mode, model, payload }))
}
